import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isProductBundle } from 'commerce-products-lib/utils/subject';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import { Button } from 'foundations-components/transitional/components/Button';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductDeactivateModal } from '../../contexts/ProductDeactivateModalContext';
import { useUpdateProductAction } from '../../contexts/UpdateProductActionContext';
import { trackActivateProduct, trackDeactivateProduct } from '../../utils/trackEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightStatusToggleButton = () => {
  const {
    product,
    associatedBundles
  } = useProductData();
  const {
    hasScope
  } = usePermissionsContext();
  const {
    openDeactivateModal
  } = useProductDeactivateModal();
  const updateProduct = useUpdateProductAction();
  const handleToggleStatus = useCallback(() => {
    if (!product) return;
    const currentStatus = getProperty(product, 'hs_status');
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    const hasBundleAssociations = !isProductBundle(product) && associatedBundles && associatedBundles.length > 0;
    const shouldShowDeactivateModal = newStatus === 'inactive' && hasBundleAssociations;
    if (shouldShowDeactivateModal) {
      openDeactivateModal();
      return;
    } else if (newStatus === 'active') {
      trackActivateProduct();
    } else {
      trackDeactivateProduct();
    }
    updateProduct({
      hs_status: newStatus
    });
  }, [product, openDeactivateModal, updateProduct, associatedBundles]);
  const hasProductEditScope = hasScope('inbounddb-product-library-write');
  if (!product || !hasProductEditScope) {
    return null;
  }
  const isProductActive = getProperty(product, 'hs_status') === 'active';
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    onClick: handleToggleStatus,
    "data-test-id": "product-status-toggle-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isProductActive ? 'actions.deactivate' : 'actions.activate'
    })
  });
};